// extracted by mini-css-extract-plugin
export default {"container":"rY-z","list":"sY-z"};